import type { DocNode as ADF } from '@atlaskit/adf-schema';
import type { User } from '@atlassian/jira-servicedesk-insight-object-types/src/common/types/object-details.tsx';
import type { PaginatedListResponse } from '@atlassian/jira-servicedesk-insight-shared-types/src/common/types/shared-types/index.tsx';

export type CommentActivityType = 'comment';
export const OBJECT_ACTIVITY_TYPE_COMMENT = 'comment';
export type HistoryActivityType = 'history';
export const OBJECT_ACTIVITY_TYPE_HISTORY = 'history';
export type ObjectActivityType = CommentActivityType | HistoryActivityType;

type ObjectActivityBase<T> = {
	actor: User;
	id: string;
	created: string;
} & T;
export type CommentActivity = ObjectActivityBase<{
	body: ADF;
	canDelete: boolean;
	canEdit: boolean;
	updated: string;
	objectId: string;
	role: number;
}>;

type HistoryActivity = ObjectActivityBase<{
	affectedAttribute: string;
	objectId: string;
	newValue: string;
	oldValue: string;
	type: number;
}>;

type ObjectActivityEntryBase<TActivityType extends ObjectActivityType, TActivity> = {
	activityType: TActivityType;
	activity: TActivity;
};

export type CommentActivityEntry = ObjectActivityEntryBase<CommentActivityType, CommentActivity>;

export type HistoryActivityEntry = ObjectActivityEntryBase<HistoryActivityType, HistoryActivity>;

export type ObjectActivityEntry = CommentActivityEntry | HistoryActivityEntry;

export type ObjectActivityResponse = PaginatedListResponse<ObjectActivityEntry>;

export type AddObjectCommentResponse = CommentActivity;

export type FetchObjectHistoryResponse = HistoryActivity;
